import { gql } from "@apollo/client";
import { StoryFieldsFragment } from "@govlaunch/story";

export default gql`
  query StoryBySlug($slug: String!, $language: String) {
    storyBySlug(slug: $slug, language: $language) {
      ...StoryFields
      viewerCanComment
    }
  }

  ${StoryFieldsFragment}
`;
